/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import PropTypes from "prop-types";

import styled, {css} from "styled-components";

const propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  size: PropTypes.string
};

const DownArrow = ({
  onClickHandler,
  size
}) => {
  return (
    <Button
      className="round-btn-hero"
      size={size}
      onClick={onClickHandler}
    >
      <Arrow />
    </Button>
  );
};

const Button = styled.div`
  border-radius: 50%;
  width: 5rem;
  width: 5rem;
  background: #193176;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${props => {
    return props.size ? css`width: ${props.size}; height: ${props.size}` : css`width: 6rem; height: 6rem;`;
  }}
`;

const Arrow = styled.span`
  background: #fff;
  height: 1.5px;
  width: 20px;
  position: relative;
  transform : rotate(90deg);
  animation: pulse 1s infinite ease-in;

  @keyframes pulse {
    0% {
      transform: rotate(90deg) translateX(0);
    }

    50% {
      transform: rotate(90deg) translateX(3px);
    }

    100% {
      transform: rotate(90deg) translateX(0);
    }
  }

  &:before, &:after {
    content: "";
    background: #fff;
    position: absolute;
    height: 2px;
    width: 12px;
  }
  &:before {
    right: -2px;
    bottom: -4px;
    transform: rotate(-45deg);
  }
  &:after {
    right: -2px;
    top: -4px;
    transform: rotate(45deg);
  }
`;

DownArrow.propTypes = propTypes;

export default DownArrow;
